import { Component, OnInit } from "@angular/core";
import { HrserviceService } from "../../hr-manager/service/hrservice.service";
import { ActivatedRoute } from "@angular/router";
import { Router } from "@angular/router";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { Notification, Subject } from "rxjs";
import { EmponboardingService } from "../../employee-onboarding/services/emponboarding.service";
import { LoginService } from "src/app/core/login/login.service";
import { LoaderService } from "src/app/core/services/loader.service";
import { MatDialog } from "@angular/material/dialog";
import { CompanyDialogComponent } from "../company-dialog/company-dialog.component";
import { ExcelService } from "src/app/core/services/excel.service";
import { CompanyFilterDialogComponent } from './company-filter-dialog.component';
@Component({
    selector: "app-company-list",
    templateUrl: "./company-list.component.html",
    styleUrls: ["./company-list.component.scss", "../shared/hr-table-styles.scss"],
    providers: [ExcelService]
})


export class CompanyListComponent implements OnInit {
    headingCompanies: string = "Companies";
    companylist: any;
    companyType: any;
    searchQuery: string = '';
    private searchSubject = new Subject<string>();
    
    // Filter state object
    currentFilters = {
        name: '',
        company_type: ''
    };
    page = 1;
    pageSize = 10;
    totalItems = 0;
    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private hrservice: HrserviceService,
        private EmpOnboardingService: EmponboardingService,
        private loginService: LoginService,
        private loaderService: LoaderService,
        private dialog: MatDialog,
        private excelService: ExcelService
    ) {
        // Setup search with debounce
        this.searchSubject
            .pipe(debounceTime(1000), distinctUntilChanged())
            .subscribe((query) => {
                // Update name filter for search
                this.currentFilters.name = query;
                this.page = 1;
                this.getCompanies();
            });
    }

    ngOnInit(): void {
        // Initialize company types first
        this.hrservice.getCompanies().subscribe((res: any) => {
            this.companyType = res.data.company_type;
            // Then load companies with filters
            this.getCompanies();
        });
    }

    // Method to handle search input from the header component
    onSearchInput(query: string): void {
        this.searchQuery = query;
        this.searchSubject.next(query);
    }

    // Get companies with filters and pagination
    getCompanies(): void {
        const params = {
            page: this.page,
            name: this.currentFilters.name || '',
            company_type: this.currentFilters.company_type || ''
        };
        this.hrservice.getCompanyList(params).subscribe((res: any) => {
            this.companylist = res.data.companies;
            this.totalItems = res.data.total_count || 0;
            if (res.data.company_type) {
                this.companyType = res.data.company_type;
            }
            // Transform company type keys to values for display
            for (var i = 0; i < this.companylist.length; i++) {
                for (var j = 0; j < this.companyType.length; j++) {
                    if (this.companylist[i].company_type == this.companyType[j].key) {
                        this.companylist[i].company_type = this.companyType[j].value;
                    }
                }
            }
        });
    }

    // Open filter dialog
    openFilterDialog(): void {
        const dialogRef = this.dialog.open(CompanyFilterDialogComponent, {
            width: '800px',
            maxWidth: '90vw',
            data: {
                filters: { ...this.currentFilters },
                companyType: this.companyType || []
            }
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.currentFilters = { ...result };
                this.page = 1;
                this.getCompanies();
            }
        });
    }

    // Handle page change
    handlePageChange(newPage: number): void {
        this.page = newPage;
        this.getCompanies();
    }

    exportCompanies(): void {
        const params = {
            name: this.currentFilters.name || '',
            company_type: this.currentFilters.company_type || ''
        };
        this.hrservice.exportCompanyList(params).subscribe((res: any) => {
            // Handle file download
            const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `companies_${this.getExportDate()}.xlsx`;
            a.click();
            window.URL.revokeObjectURL(url);
        });
    }

    private getExportDate(): string {
        return new Date().toISOString().slice(0, 10);
    }

    addCompany() {
        const dialogRef = this.dialog.open(CompanyDialogComponent, {
            width: '600px',
            data: { 
                type: 'create',
                companyType: this.companyType 
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                console.log('New company data:', result);
                // Reload companies after successful add
                this.getCompanies();
            }
        });
    }
    
    editCompany(company) {
        this.loaderService.setLoading(true);
        let type ;
        for(var i =0; i< this.companyType.length; i++){
            if(company.company_type == this.companyType[i].value){
              type = this.companyType[i].key;
            }
        }
        let dialogRef = this.dialog.open(CompanyDialogComponent, {
            data: {
                type: "edit",
                data: {
                    "company_id": company.company_id,
                    "name": company.name,
                    "code": company.code,
                    "address": company.address,
                    "company_type": type
                }
            },
        });
    }
}